(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {

  const minSlider = document.getElementById("price-slider-min");
  const maxSlider = document.getElementById("price-slider-max");

  const minInput = document.getElementById("price-min");
  const maxInput = document.getElementById("price-max");

  const minValueText = document.getElementById("price-min-value");
  const maxValueText = document.getElementById("price-max-value");

  const track = document.querySelector(".slider-track");

  if (!minSlider || !maxSlider) return;

  const maxRange = parseFloat(maxSlider.max);

  function updateSliderAndFilter(triggerSubmit = false) {

    let minVal = parseFloat(minSlider.value);
    let maxVal = parseFloat(maxSlider.value);

    if (minVal > maxVal) minSlider.value = minVal = maxVal;
    if (maxVal < minVal) maxSlider.value = maxVal = minVal;

    // Update labels with 2 decimal places
    minValueText.textContent = minVal.toFixed(2);
    maxValueText.textContent = maxVal.toFixed(2);

    // Update hidden Shopify inputs
    minInput.value = minVal;
    maxInput.value = maxVal;

    // Update track gradient
    const percentMin = (minVal / maxRange) * 100;
    const percentMax = (maxVal / maxRange) * 100;

    track.style.background =
    `linear-gradient(to right,
      #ddd ${percentMin}%,
    #acbcbb ${percentMin}%,
    #acbcbb ${percentMax}%,
      #ddd ${percentMax}%)`;

    // Trigger Shopify filter update
    if (triggerSubmit) {
      const form = minInput.closest("form");
      if (form) form.submit();
    }
  }

  minSlider.addEventListener("change", () => updateSliderAndFilter(true));
  maxSlider.addEventListener("change", () => updateSliderAndFilter(true));

  updateSliderAndFilter();

});
  } catch(e) { console.error(e); }
})();

})();
